<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'workflows.screens.assignUser.title' | translate }}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="onClickClose()"
                    [attr.aria-label]="'common.closeDialogAria' | translate" type="button">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content>
        <div fxFlex="100" fxLayout="column" fxLayoutAlign="center center" *ngIf="isLookupLoading">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>

        <div fxFlex="100" *ngIf="!isLookupLoading">
            <p *ngIf="assigneeLookupLimited" class="assignee-lookup-hint">
                {{ 'widgets.docksite.assigneeLookupLimited' | translate }}
            </p>
            <form [formGroup]="form">
                <u2b-order-assignee-fields [parentFormGroup]="form"
                                           [employees]="employees"
                                           [departments]="departments"
                                           [departmentAssigneeEnabled]="hasDepartmentsModule"
                                           appearance="fill"></u2b-order-assignee-fields>
            </form>
        </div>
    </div>

    <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button data-test="B-Abbrechen" mat-flat-button (click)="onClickClose()" type="button">
            {{ 'common.cancel' | translate }}
        </button>

        <div>
            <ng-template #saving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.saving' | translate }}</span>
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-template>

            <ng-template #notSaving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.save' | translate }}</span>
            </ng-template>

            <button type="submit" data-test="B-Speichern" mat-flat-button color="accent"
                    [disabled]="isSaving || isLookupLoading"
                    (click)="onSave()">
                <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
            </button>
        </div>

    </div>
</div>
